import React, { useState } from "react";
import DrawerWrapper from "../../../layout/DrawerWrapper";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import Collapse from "@material-ui/core/Collapse";
import { Link } from "react-router-dom";
import DoubleArrowIcon from "@material-ui/icons/DoubleArrow";
import CropRotateIcon from "@material-ui/icons/CropRotate";
import FlareIcon from "@material-ui/icons/Flare";
import BatteryChargingFullIcon from "@material-ui/icons/BatteryChargingFull";

export const Sidebar = () => {
  const [open1, setOpen1] = useState(true);
  const [open2, setOpen2] = useState(false);
  const [open3, setOpen3] = useState(false);

  const styleLink = {
    color: "white",
    fontSize: "16px",
    textDecoration: "none",
  };
  const styleListItem = {
    backgroundColor: "#2DA830",
    paddingTop: 0,
    marginTop: "-10px",
  };
  const styleListItemIcon = {
    color: "white",
    minWidth: "46px",
    marginLeft: "9px",
  };
  const styleDoubleArrow = { fontSize: "18px", marginLeft: "-9px" };

  const mainList = (
    <React.Fragment>
      {/* 2 levels */}
      <React.Fragment>
        <ListItem
          button
          onClick={() => setOpen1(!open1)}
          style={{ paddingBottom: 7 }}
        >
          <ListItemIcon style={{ color: "white" }}>
            <FlareIcon></FlareIcon>
          </ListItemIcon>
          <ListItemText primary={"Photovoltaic"} />
          {open1 ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <Collapse
          in={open1}
          timeout="auto"
          unmountOnExit
          style={{ marginLeft: "10px" }}
        >
          <List component="div">
            <Link
              style={styleLink}
              to={"/dashboard/results/photovoltaic/productivity"}
            >
              <ListItem button style={styleListItem}>
                <ListItemIcon style={styleListItemIcon}>
                  <DoubleArrowIcon style={styleDoubleArrow} />
                </ListItemIcon>
                <ListItemText primary={"Productivity"} />
              </ListItem>
            </Link>
            <Link
              style={styleLink}
              to={"/dashboard/results/photovoltaic/storage"}
            >
              <ListItem button style={styleListItem}>
                <ListItemIcon style={styleListItemIcon}>
                  <DoubleArrowIcon style={styleDoubleArrow} />
                </ListItemIcon>
                <ListItemText primary={"Storage"} />
              </ListItem>
            </Link>
            <Link
              style={styleLink}
              to={"/dashboard/results/photovoltaic/monthly_balance"}
            >
              <ListItem button style={styleListItem}>
                <ListItemIcon style={styleListItemIcon}>
                  <DoubleArrowIcon style={styleDoubleArrow} />
                </ListItemIcon>
                <ListItemText primary={"Monthly balance"} />
              </ListItem>
            </Link>
            <Link
              style={styleLink}
              to={"/dashboard/results/photovoltaic/financials"}
            >
              <ListItem button style={styleListItem}>
                <ListItemIcon style={styleListItemIcon}>
                  <DoubleArrowIcon style={styleDoubleArrow} />
                </ListItemIcon>
                <ListItemText primary={"Financials"} />
              </ListItem>
            </Link>
            <Link
              style={styleLink}
              to={"/dashboard/results/photovoltaic/environment"}
            >
              <ListItem button style={styleListItem}>
                <ListItemIcon style={styleListItemIcon}>
                  <DoubleArrowIcon style={styleDoubleArrow} />
                </ListItemIcon>
                <ListItemText primary={"Environment"} />
              </ListItem>
            </Link>
          </List>
        </Collapse>
      </React.Fragment>
      {/* 2 levels */}
      <React.Fragment>
        <ListItem
          button
          onClick={() => setOpen2(!open2)}
          style={{ paddingBottom: 7 }}
        >
          <ListItemIcon style={{ color: "white" }}>
            <CropRotateIcon></CropRotateIcon>
          </ListItemIcon>
          <ListItemText primary={"Wind Turbine"} />
          {open1 ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <Collapse
          in={open2}
          timeout="auto"
          unmountOnExit
          style={{ marginLeft: "10px" }}
        >
          <List component="div">
            <Link
              style={styleLink}
              to={"/dashboard/results/windturbine/productivity"}
            >
              <ListItem button style={styleListItem}>
                <ListItemIcon style={styleListItemIcon}>
                  <DoubleArrowIcon style={styleDoubleArrow} />
                </ListItemIcon>
                <ListItemText primary={"Productivity"} />
              </ListItem>
            </Link>
            <Link
              style={styleLink}
              to={"/dashboard/results/windturbine/storage"}
            >
              <ListItem button style={styleListItem}>
                <ListItemIcon style={styleListItemIcon}>
                  <DoubleArrowIcon style={styleDoubleArrow} />
                </ListItemIcon>
                <ListItemText primary={"Storage"} />
              </ListItem>
            </Link>
            <Link
              style={styleLink}
              to={"/dashboard/results/windturbine/monthly_balance"}
            >
              <ListItem button style={styleListItem}>
                <ListItemIcon style={styleListItemIcon}>
                  <DoubleArrowIcon style={styleDoubleArrow} />
                </ListItemIcon>
                <ListItemText primary={"Monthly balance"} />
              </ListItem>
            </Link>
            <Link
              style={styleLink}
              to={"/dashboard/results/windturbine/financials"}
            >
              <ListItem button style={styleListItem}>
                <ListItemIcon style={styleListItemIcon}>
                  <DoubleArrowIcon style={styleDoubleArrow} />
                </ListItemIcon>
                <ListItemText primary={"Financials"} />
              </ListItem>
            </Link>
            <Link
              style={styleLink}
              to={"/dashboard/results/windturbine/environment"}
            >
              <ListItem button style={styleListItem}>
                <ListItemIcon style={styleListItemIcon}>
                  <DoubleArrowIcon style={styleDoubleArrow} />
                </ListItemIcon>
                <ListItemText primary={"Environment"} />
              </ListItem>
            </Link>
          </List>
        </Collapse>
      </React.Fragment>
      {/* 2 levels */}
      <React.Fragment>
        <ListItem
          button
          onClick={() => setOpen3(!open3)}
          style={{ paddingBottom: 7 }}
        >
          <ListItemIcon style={{ color: "white" }}>
            <BatteryChargingFullIcon></BatteryChargingFullIcon>
          </ListItemIcon>
          <ListItemText primary={"PV + WT"} />
          {open1 ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <Collapse
          in={open3}
          timeout="auto"
          unmountOnExit
          style={{ marginLeft: "10px" }}
        >
          <List component="div">
            <Link
              style={styleLink}
              to={"/dashboard/results/pv_wt/productivity"}
            >
              <ListItem button style={styleListItem}>
                <ListItemIcon style={styleListItemIcon}>
                  <DoubleArrowIcon style={styleDoubleArrow} />
                </ListItemIcon>
                <ListItemText primary={"Productivity"} />
              </ListItem>
            </Link>
            <Link style={styleLink} to={"/dashboard/results/pv_wt/storage"}>
              <ListItem button style={styleListItem}>
                <ListItemIcon style={styleListItemIcon}>
                  <DoubleArrowIcon style={styleDoubleArrow} />
                </ListItemIcon>
                <ListItemText primary={"Storage"} />
              </ListItem>
            </Link>
            <Link
              style={styleLink}
              to={"/dashboard/results/pv_wt/monthly_balance"}
            >
              <ListItem button style={styleListItem}>
                <ListItemIcon style={styleListItemIcon}>
                  <DoubleArrowIcon style={styleDoubleArrow} />
                </ListItemIcon>
                <ListItemText primary={"Monthly balance"} />
              </ListItem>
            </Link>
            <Link style={styleLink} to={"/dashboard/results/pv_wt/financials"}>
              <ListItem button style={styleListItem}>
                <ListItemIcon style={styleListItemIcon}>
                  <DoubleArrowIcon style={styleDoubleArrow} />
                </ListItemIcon>
                <ListItemText primary={"Financials"} />
              </ListItem>
            </Link>
          </List>
        </Collapse>
      </React.Fragment>
    </React.Fragment>
  );

  const secondaryList = <React.Fragment></React.Fragment>;

  return (
    <DrawerWrapper
      mainList={mainList}
      secondaryList={secondaryList}
    ></DrawerWrapper>
  );
};

export default Sidebar;
